import {ListItemButton} from "@mui/material";
import {PropsWithChildren} from "react";
import {useLocation, useResolvedPath} from "react-router";
import LinkBehavior from "./LinkBehavior";
import {isMenuItemActive} from "../utils/navigation";

export function NavButton({
                              id,
                              href,
                              indent,
                              onClick,
                              children,
                          }: PropsWithChildren<{
    id: string;
    href: string;
    indent?: boolean;
    onClick?: () => void;
}>) {
    const path = useResolvedPath(href);
    const location = useLocation();
    const active = isMenuItemActive(location.pathname, path.pathname);

    return (
        <ListItemButton
            id={id}
            component={LinkBehavior}
            href={href}
            selected={active}
            onClick={onClick}
            sx={{pl: indent ? 9 : undefined}}
        >
            {children}
        </ListItemButton>
    );
}
